import React from 'react'
import { Link } from 'react-router-dom'
import { Ordinal32 } from '@carbon/icons-react'

const OutputLink = ({ labelText, id, disabled }) => {
  const renderLink = () => {
    if (!disabled) {
      return (
        <Link className='output-link' to={`/output/${id}`}>
          <div className='vertical-items'>
            <Ordinal32 className='progress-icon' />
            <span>{labelText}</span>
          </div>
        </Link>
      )
    } else {
      return (
        <div className='output-link-disabled'>
          <Ordinal32 className='progress-icon' />
          <span>{labelText}</span>
        </div>
      )
    }
  }

  return renderLink()
}

export default OutputLink
